import * as React from 'react';
import { IconPaths } from 'src/icons';
import { createUser } from 'src/store/user/action';
import { TypeTranslations, User } from 'src/store/user/types';
import { ApplicationState } from 'src/store';
import { connect } from 'react-redux';

interface Props {
  createUser: typeof createUser;
  showHeader?: boolean;
}

interface State {
  value: User;
}

const initialState = {
  value: {
    id: '',
    name: '',
    email: '',
    role: {
      name: 'business'
    },
    password: '',
    username: ''
  }
};

class CreateNewUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = initialState;
  }

  onSave = (e: any) => {
    e.preventDefault();
    if (this.state.value) {
      this.props.createUser(this.state.value, () => {
        this.setState(initialState);
      });
    }
  };

  onChangeUser = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const name = e.target.name;

    this.setState(prevState => {
      return {
        ...prevState,
        value: {
          ...prevState.value,
          [name]: inputValue
        }
      };
    });
  };

  onChangeType = (event: any) => {
    const selected = event.target.value;

    this.setState(prevState => {
      return {
        ...prevState,
        value: {
          ...prevState.value,
          role: {
            name: selected
          }
        }
      };
    });
  };

  render() {
    return (
      <div className="container">
        <div className="col-12">
          <form onSubmit={this.onSave}>
            <table className="manageTable">
              {this.props.showHeader && (
                <thead>
                  <tr>
                    <th />
                    <th>Name</th>
                    <th>Benutzername</th>
                    <th>Email</th>
                    <th>Typ</th>
                    <th>Passwort</th>
                    <th />
                    <th />
                  </tr>
                </thead>
              )}

              <tbody>
                <tr className="editing">
                  <td>
                    <button onClick={this.onSave} className="noStyle">
                      <img src={IconPaths['save-icon']} title="Speichern" />
                    </button>
                  </td>
                  <td>
                    <input
                      autoComplete="off"
                      type="text"
                      value={this.state.value.name}
                      name="name"
                      onChange={this.onChangeUser}
                    />
                  </td>
                  <td>
                    <input
                      autoComplete="off"
                      type="text"
                      value={this.state.value.username}
                      name="username"
                      onChange={this.onChangeUser}
                    />
                  </td>
                  <td>
                    <input
                      autoComplete="off"
                      type="text"
                      value={this.state.value.email}
                      name="email"
                      onChange={this.onChangeUser}
                    />
                  </td>
                  <td>
                    <select
                      value={this.state.value.role.name}
                      name="role[name]"
                      onChange={this.onChangeType}
                    >
                      <option value="business">{TypeTranslations.business}</option>
                      <option value="guide">{TypeTranslations.guide}</option>
                      <option value="admin">{TypeTranslations.admin}</option>
                    </select>
                  </td>
                  <td>
                    <input
                      autoComplete="off"
                      type="text"
                      value={this.state.value.password}
                      name="password"
                      onChange={this.onChangeUser}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ users }: ApplicationState) => ({
  users: users.suggestions,
  loading: users.loading,
  error: users.errors
});

const mapDispatchToProps = (dispatch: any) => ({
  createUser: (user: User, clearForm: any) => dispatch(createUser(user, clearForm))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateNewUser);



// WEBPACK FOOTER //
// ./src/pages/Management/UserManagement/CreateNewUser/CreateNewUser.tsx